import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { UploadValidationTemplate as template } from './upload-validation.template';
import { UploadValidationStyles as styles } from './upload-validation.styles';
import { ObjectValidation } from '../../../../types';

const name = 'upload-validation';

@customElement({
  name,
  template,
  styles,
})
export class UploadValidation extends FASTElement {
  @attr errorProjectList: Array<ObjectValidation> = [];
  connectedCallback() {
    super.connectedCallback();
  }
}
